import { NormalizedRoute } from './route-types'
import * as Fmt from './route-formatting'
import GeojsonUtils from './geojson-utils'
import simplify from 'simplify-geojson'

export function normalizedRouteToFeature(route: NormalizedRoute, index: number) {
  const currentTimeMins = Fmt.getRouteTimeMinutes(route)
  const normalTimeMins = Fmt.getNormalTimeMinutes(route)

  const routeGeomFeature = GeojsonUtils.createFeature(
    {},
    'LineString',
    route.decodedPath.map((p) => [p.lng, p.lat]),
  )

  return GeojsonUtils.createFeature(
    {
      id: index,
      name: route.description,
      comparativeTime: Fmt.formatComparativeTime(route),
      currentTime: Fmt.formatTime(currentTimeMins),
      unformattedTime: currentTimeMins,
      normalTime: Fmt.showNormalTime(route) ? Fmt.formatTime(normalTimeMins) : '',
      totalLength: route.distanceMeters / 1000,
      startLatitude: route.startLocation.lat,
      startLongitude: route.startLocation.lng,
      endLatitude: route.endLocation.lat,
      endLongitude: route.endLocation.lng,
      hasLoadedRelated: false,
      related: [],
      isGoogleRoute: true,
      overviewPolyline: route.encodedPolyline,
      hasTolls: route.hasTolls,
      isTollRoad: route.hasTolls ? 'Yes' : 'No',
      simpleGeometry: simplify(routeGeomFeature, 0.0005).geometry,
    },
    'LineString',
    routeGeomFeature.geometry.coordinates,
  )
}
